import fetchData from "../utils/HttpClient";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";
import {CustomerManagerInterface} from "../interfaces/customer/CustomerManagerInterface";
import {CreateOrderInterface} from "../interfaces/checkout/CreateOrderInterface";
import {CreateOrderResponseInterface} from "../interfaces/checkout/CreateOrderResponseInterface";
import {CustomerOrderInterface} from "../interfaces/customer/CustomerOrderInterface";
import {CustomerOrderListInterface} from "../interfaces/customer/CustomerOrderListInterface";
import {BillInterface} from "../interfaces/customer/BillInterface";

export function login(email: string, password: string): Promise<{status: string, customer: CustomerInterface, manager: CustomerManagerInterface|null}> {
    return fetchData('/api/srz/user/login', {
        email: email,
        password: password
    }, 'POST')
}

export function createOrder(order: CreateOrderInterface): Promise<CreateOrderResponseInterface> {
    return fetchData('/api/srz/order/create', order, 'POST')
}

export function orderList(customer: CustomerInterface, manager: CustomerManagerInterface|null = null): Promise<CustomerOrderListInterface[]> {
    return fetchData('/api/srz/order/list', {customer: customer, manager: manager}, 'POST', customer)
}

export function orderDetails(orderId: string, customer: CustomerInterface|CustomerManagerInterface): Promise<CustomerOrderInterface> {
    return fetchData('/api/srz/order/details', {customer: customer, order_id: orderId}, 'POST', customer)
}

export function billApprove(bill: BillInterface, customer: CustomerInterface|CustomerManagerInterface): Promise<{status: string}> {
    return fetchData('/api/srz/order/bill/approve', {customer: customer, bill: bill}, 'POST', customer)
}

export function managers(customer: CustomerInterface): Promise<CustomerManagerInterface[]> {
    return fetchData('/api/srz/customer-manager/list', {customer: customer}, 'POST', customer)
}

export function saveManager(customer: CustomerInterface, manager: CustomerManagerInterface): Promise<CustomerManagerInterface> {
    return fetchData('/api/srz/customer-manager/save', {customer: customer, manager: manager}, 'POST', customer)
}

export function removeManager(customer: CustomerInterface, manager: CustomerManagerInterface): Promise<CustomerManagerInterface> {
    return fetchData('/api/srz/customer-manager/remove', {customer: customer, manager: manager}, 'POST', customer)
}

export function linkOrderToManager(customer: CustomerInterface, order: CustomerOrderInterface, managerId: number[]): Promise<CustomerManagerInterface> {
    return fetchData('/api/srz/order/link-customer-manager-to-order', {customer: customer, managers_id: managerId, order: order}, 'POST', customer)
}
